import React, { useState, useRef } from "react";
import styled from "styled-components";
import Common from "Common";
import { COLORS } from "~/styles/Consts";
import EmptyState from "../EmptyState";
import { Form, Field } from "react-final-form";
import arrayMutators from "final-form-arrays";
import { FieldArray } from "react-final-form-arrays";
import Firebase from "firebase";

const { Table, Icon, Modal, Button, Popup, Menu, Grid, Confirm } = Common;

const DocPreview = styled.div`
  cursor: pointer;
`;

const CreateButton = styled.div`
  width: 100%;
  float: left;
  margin-bottom: 15px;
  margin-top: 5px;
`;

const PopupStyled = styled(Popup)`
  padding: 0 !important;
`;

const MenuStyled = styled(Menu)`
  box-shadow: none !important;
  line-height: 1.2 !important;
  .header {
    margin-top: 0.5rem !important;
    color: ${COLORS.lightGray} !important;
  }
  .item {
    padding: 0 !important;
    a,
    div {
      padding: 0.5rem 0.8rem !important;
    }
  }
`;

const ActionsWrapper = styled.div`
  cursor: context-menu;
  text-align: center;
`;
const DeleteWrapper = styled.span`
  color: ${COLORS.error} !important;
  font-weight: bold;
`;

// TODO Refactor to be more generic (kludging task attachment support, but should be generic)
const ListPoll = ({ pollList, isAdmin }) => {
  const [popupState, setPopupState] = useState(false);
  const [preview, setPreview] = useState(null);
  const [previewModal, setPreviewModal] = useState({});
  const [showsubmitModal, setShowSubmitModal] = useState(false);
  const [submitModalData, setSubmitModalData] = useState({});
  const [input, setInput] = useState();
  const [deleteItem, setDeleteItem] = useState(null);

  const popupRef = useRef({});

  const handlePreview = () => setPreview(!preview);
  const renderPreviewHandle = (pollItem) => {
    setPreviewModal(pollItem);
    handlePreview();
  };

  const addPollApi = (pollItem) => {
    console.log("pollItempollItem", pollItem);
    Firebase.database()
      .ref("PollData")
      .push()
      .set({
        PollData: pollItem,
      })
      .then((doc) => {
        // nothing to do here since you already have a
        // connection pulling updates to addPollApi
      })
      .catch((error) => {
        dispatch(todoActions.showError("Error adding Todo to database"));
        console.error(error);
      });
  };

  const renderDiffFields = (pItem) => {
    let c;
    switch (pItem.questionType) {
      case "radio": {
        c = (
          <div key={pItem.question}>
            {!pItem.options ? (
              <label>{`No Options selected`}</label>
            ) : (
              pItem.options.length > 0 &&
              pItem.options.map((option) => {
                return (
                  <>
                    <Field
                      id={`${option.option}`}
                      name={`${pItem.question}`}
                      type="radio"
                      value={`${option.option}`}
                      component={`input`}
                    ></Field>
                    <label>{`${option.option}`}</label>
                  </>
                );
              })
            )}
          </div>
        );
        break;
      }
      case "checkbox": {
        c = (
          <div key={pItem.question}>
            {!pItem.options ? (
              <label>{`No Options selected`}</label>
            ) : (
              pItem.options.length > 0 &&
              pItem.options.map((option, optIndex) => {
                return (
                  <>
                    <Field
                      id={`${option.option}`}
                      name={`${pItem.question}`}
                      component={`input`}
                      type={`${pItem.questionType}`}
                      value={`${option.option}`}
                    />
                    <label>{`${option.option}`}</label>
                  </>
                );
              })
            )}
          </div>
        );
        break;
      }
      case "input": {
        c = (
          <Field
            name={`${pItem.question}`}
            component={`input`}
            type={`${pItem.questionType}`}
            placeholder="type Answer"
          />
        );
        break;
      }

      default: {
        break;
      }
    }
    return c;
  };

  const renderSubmitPollsHandler = (pollItem) => {
    setSubmitModalData(pollItem);
    renderSubmitPollHandle();
    addPollApi(pollItem);
  };
  const renderSubmitPollHandle = () => {
    setShowSubmitModal(!showsubmitModal);
  };

  const handlePopupState = () => {
    setPopupState(!popupState);
  };

  const handleSetDeletePoll = (id, pollItem) => {
    setDeleteItem(id ? { id, pollItem } : null);
    if (id && popupRef.current[id]) {
      popupRef.current[id].click();
    }
  };
  const handleOnDeletePoll = () => {
    handleSetDeletePoll();
  };

  const handleOnCancelDeletePoll = () => {
    handleSetDeletePoll();
  };

  const renderDeletePoll = () => {
    if (!deleteItem || !isAdmin) return null;
    const { pollItem } = deleteItem;
    return (
      <Confirm
        elementProps={{
          content: "Delete",
          icon: "trash alternate",
          size: "tiny",
          fluid: true,
          styling: { backgroundColor: COLORS.error, color: COLORS.white },
        }}
        header={`Delete`}
        content={`Are you sure you want to delete?`}
        confirmButton="Delete"
        cb={() => handleOnDeletePoll(pollItem)}
        cancelCb={handleOnCancelDeletePoll}
        element={() => null}
        isOpen={!!deleteItem}
      />
    );
  };

  const renderMenu = (pollItem) => {
    return (
      <MenuStyled size="small" vertical compact fluid>
        <Menu.Item>
          <Menu.Item>
            <Menu.Item onClick={() => renderPreviewHandle(pollItem)}>
              <Icon name="search plus" />
              Open Poll
            </Menu.Item>
            {isAdmin && (
              <Menu.Item onClick={() => handleSetDeletePoll(pollItem)}>
                <Icon name="trash alternate" color={COLORS.error} />
                <DeleteWrapper>Delete…</DeleteWrapper>
              </Menu.Item>
            )}
          </Menu.Item>
        </Menu.Item>
      </MenuStyled>
    );
  };

  const renderMoreActionsIcon = (pollItem) => {
    const { id } = pollItem;

    return (
      <PopupStyled
        content={renderMenu(pollItem)}
        trigger={
          <ActionsWrapper
            ref={(ref) => {
              popupRef.current[id] = ref;
            }}
          >
            <Icon name="ellipsis vertical" />
          </ActionsWrapper>
        }
        size="mini"
        position="top center"
        on="click"
        onOpen={() => handlePopupState()}
        onClose={() => handlePopupState()}
        hideOnScroll
      />
    );
  };

  const renderSubmitModal = (submitData) => {
    return (
      <>
        <Modal open={showsubmitModal} onClose={() => renderSubmitPollHandle()}>
          <Modal.Header>
            <Grid columns={2}>
              <Grid.Column>{`Submit - ${submitData.poll_title}`}</Grid.Column>
              <Grid.Column textAlign="right" verticalAlign="middle">
                <Icon
                  link
                  name="close"
                  onClick={() => renderSubmitPollHandle()}
                />
              </Grid.Column>
            </Grid>
          </Modal.Header>

          <Form
            onSubmit={onSubmit}
            mutators={{
              ...arrayMutators,
            }}
            initialValues={{
              question: submitData.questions,
            }}
            render={({
              handleSubmit,
              form: {
                mutators: { push, pop },
              },
            }) => {
              return (
                <form onSubmit={handleSubmit}>
                  <FieldArray name="question">
                    {({ fields }) =>
                      fields.value.map((pItem, index) => (
                        <div key={pItem}>
                          <Modal.Content key={index}>
                            {`${index + 1}.) ${pItem.question}`}
                          </Modal.Content>
                          {renderDiffFields(pItem, index)}
                        </div>
                      ))
                    }
                  </FieldArray>
                </form>
              );
            }}
          />
          <Modal.Actions>
            <Button onClick={() => renderSubmitPollHandle()}>
              Submit Poll
            </Button>
          </Modal.Actions>
        </Modal>
      </>
    );
  };

  const renderSubmitPollButton = (pollItem) => {
    return (
      <>
        <CreateButton>
          <Button
            size="mini"
            color="green"
            onClick={() => renderSubmitPollsHandler(pollItem)}
          >
            Poll
          </Button>
        </CreateButton>
      </>
    );
  };

  const renderPreview = (previewData) => {
    return (
      <>
        <Modal open={preview} onClose={() => handlePreview()}>
          <Modal.Header>
            <Grid columns={2}>
              <Grid.Column>{previewData.poll_title}</Grid.Column>
              <Grid.Column textAlign="right" verticalAlign="middle">
                <Icon link name="close" onClick={() => handlePreview()} />
              </Grid.Column>
            </Grid>
          </Modal.Header>

          {previewData.questions &&
            previewData.questions.length > 0 &&
            previewData.questions.map((pItem, i) => {
              return (
                <>
                  <Modal.Content key={i}>
                    {`${i + 1}.) ${pItem.question}`}
                  </Modal.Content>

                  {pItem.questionType === "input" && (
                    <Modal.Content>{`Type:${pItem.questionType}`}</Modal.Content>
                  )}

                  {pItem.questionType !== "input" &&
                    pItem?.options &&
                    pItem?.options?.length > 0 &&
                    pItem?.options?.map((option, j) => {
                      return (
                        <>
                          <Modal.Content>{option.option}</Modal.Content>
                        </>
                      );
                    })}
                </>
              );
            })}

          <Modal.Actions>
            <Button onClick={() => handlePreview()}>Close</Button>
          </Modal.Actions>
        </Modal>
      </>
    );
  };

  const renderPolls = (pollItem, index) => {
    const { poll_title } = pollItem;
    return (
      <>
        <Table.Row key={poll_title}>
          <Table.Cell>
            <DocPreview textAlign="center" verticalAlign="middle">
              {poll_title}
            </DocPreview>
          </Table.Cell>
          <Table.Cell>{renderMoreActionsIcon(pollItem)}</Table.Cell>
          <Table.Cell>{renderSubmitPollButton(pollItem)}</Table.Cell>
        </Table.Row>

        {renderPreview(previewModal)}
        {renderSubmitModal(submitModalData)}
        {deleteItem && renderDeletePoll(index)}
      </>
    );
  };

  const renderEmptyState = () => (
    <EmptyState icon="file" message="No Polls here" />
  );

  return (
    <>
      {!pollList.length ? (
        renderEmptyState()
      ) : (
        <Table basic="very" celled collapsing>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Title Name</Table.HeaderCell>
              <Table.HeaderCell>Actions</Table.HeaderCell>
              <Table.HeaderCell>Submit</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>{pollList.map(renderPolls)}</Table.Body>
        </Table>
      )}
    </>
  );
};

export default ListPoll;
